import classNames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import {
  LARGE_ICON_MAP,
  MessageBoxSC,
  msgBoxCls,
  SMALL_ICON_MAP,
  TextWrapper,
  useBoxColors,
} from './message-box.styled';
import type {
  MessageBoxLargeProps,
  MessageBoxSmallProps,
  TMessageBoxVariant,
} from './message-box.types';

type MessageBoxProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  variant?: TMessageBoxVariant;
} & (MessageBoxSmallProps | MessageBoxLargeProps);

const MessageBox: React.FunctionComponent<MessageBoxProps> = ({
  variant = 'info',
  size = 'large',
  style,
  footer,
  caption,
  description,
  title,
  ...rest
}) => {
  const theme = useTheme();
  const colors = useBoxColors();
  const Icon = (size === 'large' ? LARGE_ICON_MAP : SMALL_ICON_MAP)[variant];

  const iconSize = size === 'large' ? 40 : 20;
  const iconProps: React.SVGProps<SVGSVGElement> = {
    color: colors[variant].icon,
    width: iconSize,
    height: iconSize,
  };

  return (
    <MessageBoxSC
      {...rest}
      size={size}
      style={{
        ...style,
        backgroundColor: colors[variant].background,
        borderRadius: size === 'large' ? theme.radius.large : theme.radius.small,
      }}
      className={classNames(rest.className, msgBoxCls.wrapper)}
    >
      <Icon {...iconProps} className={msgBoxCls.icon} />
      <TextWrapper size={size}>
        {size === 'large' ? (
          <>
            <div className={classNames(msgBoxCls.title, `${msgBoxCls.title}-${size}`)}>{title}</div>
            {description ? <div className={msgBoxCls.description}>{description}</div> : null}
            {footer ? <div className={msgBoxCls.footer}>{footer}</div> : null}
          </>
        ) : size === 'small' ? (
          <div style={{ color: colors[variant].text }} className={msgBoxCls.caption}>
            {caption}
          </div>
        ) : null}
      </TextWrapper>
    </MessageBoxSC>
  );
};

export default MessageBox;
